import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class BackButtonService {

  private backButtonVisible = false;

  constructor(private location: Location) {
  }

  public onBackButtonClick() {
    this.location.back();
  }

  public setBackButtonVisible() {
    this.backButtonVisible = true;
  }

  public setBackButtonHidden() {
    this.backButtonVisible = false;
  }

  public isBackButtonVisible(): boolean {
    return this.backButtonVisible;
  }
}
